import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailChangeService } from '../../services/email-change.service';

interface SendOtpResponse {
  status: number;
  message: string;
  output?: {
    message: string;
  };
  time?: string;
}

@Component({
  selector: 'app-change-email-dialog',
  templateUrl: './change-email-dialog.component.html',
  styleUrls: ['./change-email-dialog.component.scss']
})

export class ChangeEmailDialogComponent {
  step: 'email' | 'otp' = 'email';
  form: FormGroup;
  otpForm: FormGroup;
  sentEmail = '';
  otpError: string = '';
  emailError: string = '';
  resendMessage = '';
resendDisabled = false;
resendCountdown = 60;
countdownInterval: any;
  constructor(
    private fb: FormBuilder,
    private emailService: EmailChangeService,
    private dialogRef: MatDialogRef<ChangeEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentEmail: string }
  ) {
    this.form = this.fb.group({
      email: [data.currentEmail, [Validators.required, Validators.email]]
    });

    this.otpForm = this.fb.group({
      code: ['', [Validators.required, Validators.minLength(4)]]
    });
  }

  sendOtp() {
    if (this.form.invalid) return;

    const email = this.form.value.email;
    this.sentEmail = email;

    this.emailService.sendOtp(email).subscribe({
      next: (res: SendOtpResponse) => {
        if (res.output?.message === 'Email is the same as current email') {
          this.emailError = res.output.message;
        } else {
          this.step = 'otp';
          this.emailError = '';
        }
      },
      error: (err) => {
        const apiMessage = err?.error?.error?.message || err?.error?.message || 'Something went wrong';
        this.emailError = apiMessage;
        this.form.get('email')?.setErrors({ api: true });
      }
    });
  }



  verifyOtp() {
    const code = this.otpForm.value.code;
    this.emailService.verifyOtp(this.sentEmail, code).subscribe({
      next: () => {
        this.dialogRef.close(this.sentEmail);
        location.reload();
      },
      error: (err) => {
        console.error('OTP verification error:', err);
        if (err?.error?.error?.message === 'Invalid or expired OTP') {
          this.otpForm.get('code')?.setErrors({ incorrect: true });
          this.otpError = err?.error?.error?.message;
        } else {
          this.otpError = 'Something went wrong';
        }
      }
    });
  }


  resendOtp() {
    if (this.resendDisabled) return;

    this.emailService.sendOtp(this.sentEmail).subscribe({
      next: () => {
        this.resendMessage = 'OTP has been resent successfully.';
        this.resendDisabled = true;
        this.startCountdown();
      },
      error: () => {
        this.resendMessage = 'Failed to resend OTP. Please try again.';
      }
    });
  }

  startCountdown() {
    this.resendCountdown = 60;
    this.countdownInterval = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown <= 0) {
        clearInterval(this.countdownInterval);
        this.resendDisabled = false;
        this.resendMessage = '';
      }
    }, 1000);
  }



  close() {
    this.dialogRef.close();
  }


onOtpInput(event: any, index: number) {
  const value = event.target.value;
  if (value && index < 3) {
    // Move to next input
    const nextInput = document.querySelector(`input:nth-of-type(${index + 2})`) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }

  // Update the form control with combined OTP
  this.updateOtpFormControl();

  // Add filled class for styling
  event.target.classList.toggle('filled', value !== '');
}

onOtpKeydown(event: any, index: number) {
  if (event.key === 'Backspace' && !event.target.value && index > 0) {
    // Move to previous input on backspace
    const prevInput = document.querySelector(`input:nth-of-type(${index})`) as HTMLInputElement;
    if (prevInput) {
      prevInput.focus();
    }
  }
}

private updateOtpFormControl() {
  const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
  let otpValue = '';
  inputs.forEach(input => {
    otpValue += input.value;
  });
  this.otpForm.controls['code'].setValue(otpValue);
}
ngOnDestroy() {
  clearInterval(this.countdownInterval);
}

}

